export default __webpack_public_path__ + "static/media/chalk-pointer.9f53e197.png";